import React, { useState } from "react";
import api from '../services/axios';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { styled } from "@mui/system";
import Juliaca from "../assets/img/Juliaca.png";
import Aniversario from "../assets/img/aniversario.png";

/* ================== STYLES ================== */

const HeaderContainer = styled(AppBar)(({ theme }) => ({
  backgroundColor: "#ffffff",
  position: "static",
  width: "100%",
  zIndex: 1000,
}));

const LogoContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "5px",

  img: {
    height: "50px",
  },

  [theme.breakpoints.down("sm")]: {
    img: {
      height: "38px",
    },
  },
}));

const NavLinks = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginLeft: "auto",

  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

const StyledLink = styled("a")({
  background: "linear-gradient(90deg, #034d5aff, #2a3b87)",
  WebkitBackgroundClip: "text",
  color: "transparent",
  fontWeight: "bold",
  letterSpacing: "1px",
  textDecoration: "none",
  marginLeft: "20px",
  fontSize: "16px",
  transition: "all 0.3s ease",

  "&:hover": {
    color: "#2a3b87",
    transform: "scale(1.1)",
  },
});

/* ================== COMPONENT ================== */

function Header() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  // ✅ Ahora usamos sessionStorage
  const storedUser = sessionStorage.getItem("name");
  const role = sessionStorage.getItem("role");

  const isAdmin = role === "admin" || role === "superadmin";

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleLogout = async () => {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      console.error("Error logout", error);
    } finally {

      // ✅ Eliminamos solamente los datos de sesión
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("name");
      sessionStorage.removeItem("role");
      sessionStorage.removeItem("email");
      sessionStorage.removeItem("sessionExpired");

      window.location.href = "/";
    }
  };

  /* ================== DRAWER ================== */

  const drawerContent = (
    <Box sx={{ width: 260, p: 2 }}>
      <List>

        <ListItem button component="a" href="/">
          <ListItemText primary="Inicio" />
        </ListItem>

        <ListItem button component="a" href="/listcatalogo">
          <ListItemText primary="Catálogo" />
        </ListItem>

        {isAdmin && (
          <ListItem button component="a" href="/admin">
            <ListItemText primary="Administrador" />
          </ListItem>
        )}

        <Box sx={{ mt: 2 }}>
          {storedUser ? (
            <>
              <Typography sx={{ mb: 1, fontWeight: "bold" }}>
                👋 {storedUser.split(" ")[0]}
              </Typography>

              <Button
                fullWidth
                variant="contained"
                onClick={handleLogout}
              >
                Cerrar Sesión
              </Button>
            </>
          ) : (
            <Button
              fullWidth
              variant="outlined"
              href="/login"
            >
              Ingresar
            </Button>
          )}
        </Box>

      </List>
    </Box>
  );

  /* ================== RENDER ================== */

  return (
    <HeaderContainer>
      <Toolbar sx={{ justifyContent: "space-between" }}>

        {/* LOGOS */}
        <LogoContainer>
          <img src={Juliaca} alt="San Román" />
          <img src={Aniversario} alt="Aniversario" />
        </LogoContainer>

        {/* MOBILE / TABLET */}
        {isMobile && (
          <>
            <IconButton onClick={() => setDrawerOpen(true)}>
              <MenuIcon sx={{ color: "#0088cc" }} />
            </IconButton>

            <Drawer
              anchor="right"
              open={drawerOpen}
              onClose={() => setDrawerOpen(false)}
            >
              {drawerContent}
            </Drawer>
          </>
        )}

        {/* DESKTOP */}
        <NavLinks>

          <StyledLink href="/">Inicio</StyledLink>

          <StyledLink href="/listcatalogo">
            Catálogo
          </StyledLink>

          {isAdmin && (
            <StyledLink href="/admin">
              Administrador
            </StyledLink>
          )}

          {storedUser ? (
            <>
              <Typography
                sx={{
                  ml: 2,
                  fontWeight: "bold",
                  color: "#1d2b69"
                }}
              >
                ¡Hola, {storedUser.split(" ")[0]}!
              </Typography>

              <Button
                variant="contained"
                onClick={handleLogout}
                sx={{
                  ml: 2,
                  background:
                    "linear-gradient(90deg, #034d5aff, #2a3b87)",

                  "&:hover": {
                    transform: "scale(1.05)",
                  },
                }}
              >
                Cerrar Sesión
              </Button>
            </>
          ) : (
            <StyledLink href="/login">
              Ingresar
            </StyledLink>
          )}

        </NavLinks>

      </Toolbar>
    </HeaderContainer>
  );
}

export default Header;